import { AppUser } from 'Src/views/App/App';
import axios from 'Src/helpers/api/axiosInstance';

export function getUnionDashboard(user: AppUser) {
  const { roleSessionKey: key, activeSchoolId } = user;
  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/union-dashboard`, { headers: { usid: key } })
    .then(response => response.data);
}
